// iOS-style grouped inset row: label on the left, field/value on the right
const FieldRow = ({ label, error, last, children }) => {
  return (
    <div className={last ? "" : "border-b border-gray-100"}>
      <div className="flex items-center gap-3 px-4 min-h-[52px]">
        <label className="text-[15px] text-[#1f2937] shrink-0">{label}</label>
        <div className="flex-1 flex items-center justify-end gap-2 py-2.5">
          {children}
        </div>
      </div>
      {error && (
        <p className="px-4 pb-2 -mt-1 text-xs text-red-500 text-right">
          {error}
        </p>
      )}
    </div>
  );
};

// shared input styling for rows
export const rowInputClass =
  "flex-1 min-w-0 bg-transparent text-right text-[15px] text-gray-600 placeholder-gray-400 focus:outline-none";

export default FieldRow;
